import { IInventoryPage } from '../../inventory-page.interface';


export const GENERAL_NOT_FOUND_PAGE: IInventoryPage = {
	'route': '/not-found',
	'title': 'Page Not Found',
	'uiReference': [
		'Page not found',
		'The page may have moved, or the address may be incorrect.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/shared-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/page-not-found/page-not-found.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/page-not-found/page-not-found.component.html'
	]
};
